import { t } from 'i18next'
import Carousel from './CustomCarousel'
import { Stack, Typography } from '@mui/material'
import { Trans } from 'react-i18next'
import { Item } from '../../../../../store/types'
import i18n from '../../../../../config/i18n'
import { environment } from '../../../../../enviroments/enviroment'


const translationBase = 'components.infoSidebar.schedule.carousel.modifyMany'
const urlBase = `${environment.publicUrl}/assets/image/carousel/info/group`

const LIGHT_PL_1 = `${urlBase}/group-light-PL-1.jpg`
const LIGHT_PL_2 = `${urlBase}/group-light-PL-2.jpg`
const LIGHT_PL_3 = `${urlBase}/group-light-PL-3.jpg`
const LIGHT_PL_4 = `${urlBase}/group-light-PL-4.jpg`
const LIGHT_PL_5 = `${urlBase}/group-light-PL-5.jpg`
const LIGHT_PL_6 = `${urlBase}/group-light-PL-6.jpg`

const DARK_PL_1 = `${urlBase}/group-dark-PL-1.jpg`
const DARK_PL_2 = `${urlBase}/group-dark-PL-2.jpg`
const DARK_PL_3 = `${urlBase}/group-dark-PL-3.jpg`
const DARK_PL_4 = `${urlBase}/group-dark-PL-4.jpg`
const DARK_PL_5 = `${urlBase}/group-dark-PL-5.jpg`
const DARK_PL_6 = `${urlBase}/group-dark-PL-6.jpg`

const LIGHT_EN_1 = `${urlBase}/group-light-EN-1.jpg`
const LIGHT_EN_2 = `${urlBase}/group-light-EN-2.jpg`
const LIGHT_EN_3 = `${urlBase}/group-light-EN-3.jpg`
const LIGHT_EN_4 = `${urlBase}/group-light-EN-4.jpg`
const LIGHT_EN_5 = `${urlBase}/group-light-EN-5.jpg`
const LIGHT_EN_6 = `${urlBase}/group-light-EN-6.jpg`

const DARK_EN_1 = `${urlBase}/group-dark-EN-1.jpg`
const DARK_EN_2 = `${urlBase}/group-dark-EN-2.jpg`
const DARK_EN_3 = `${urlBase}/group-dark-EN-3.jpg`
const DARK_EN_4 = `${urlBase}/group-dark-EN-4.jpg`
const DARK_EN_5 = `${urlBase}/group-dark-EN-5.jpg`
const DARK_EN_6 = `${urlBase}/group-dark-EN-6.jpg`

const ModifyManyCarousel = () => {
  const isPolish = i18n.language === 'pl'
  const PlanCarouselItems: Item[] = [
    {
      subtitle: t(`${translationBase}.panel.subtitle`),
      description: t(`${translationBase}.panel.description`),
      imageLight: isPolish ? LIGHT_PL_1 : LIGHT_EN_1,
      imageDark: isPolish ? DARK_PL_1 : DARK_EN_1,
      key: 'carousel-schedule-info-modify-many-1',
    },
    {
      subtitle: t(`${translationBase}.timePeriods.subtitle`),
      description: t(`${translationBase}.timePeriods.description`),
      imageLight: isPolish ? LIGHT_PL_2 : LIGHT_EN_2,
      imageDark: isPolish ? DARK_PL_2 : DARK_EN_2,
      key: 'carousel-schedule-info-modify-many-2',
    },
    {
      subtitle: t(`${translationBase}.timePeriodError.subtitle`),
      description: t(`${translationBase}.timePeriodError.description`),
      imageLight: isPolish ? LIGHT_PL_3 : LIGHT_EN_3,
      imageDark: isPolish ? DARK_PL_3 : DARK_EN_3,
      key: 'carousel-schedule-info-modify-many-3',
    },
    {
      subtitle: t(`${translationBase}.repeat.subtitle`),
      description: (
        <Stack gap={2}>
          <Typography>{t(`${translationBase}.repeat.description-1`)}</Typography>
          <Typography>
            <Trans i18nKey={`${translationBase}.repeat.description-2`} />
          </Typography>
          <Typography>
            <Trans i18nKey={`${translationBase}.repeat.description-3`} />
          </Typography>
        </Stack>
      ),
      imageLight: isPolish ? LIGHT_PL_4 : LIGHT_EN_4,
      imageDark: isPolish ? DARK_PL_4 : DARK_EN_4,
      key: 'carousel-schedule-info-modify-many-4',
    },
    {
      subtitle: t(`${translationBase}.weekDays.subtitle`),
      description: t(`${translationBase}.weekDays.description`),
      imageLight: isPolish ? LIGHT_PL_5 : LIGHT_EN_5,
      imageDark: isPolish ? DARK_PL_5 : DARK_EN_5,
      key: 'carousel-schedule-info-modify-many-5',
    },
    {
      subtitle: t(`${translationBase}.duration.subtitle`),
      description: t(`${translationBase}.duration.description`),
      imageLight: isPolish ? LIGHT_PL_6 : LIGHT_EN_6,
      imageDark: isPolish ? DARK_PL_6 : DARK_EN_6,
      key: 'carousel-schedule-info-modify-many-6',
    },
  ]

  return <Carousel title={t(`${translationBase}.title`)} items={PlanCarouselItems} />
}

export default ModifyManyCarousel
